import { useRouter } from "next/router";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useContext } from "react";

import { ThemeProvider } from "@mui/material";

import { AppContext, ThemeMode } from "@context/context";
import MDXPageEN from "@portfolios/port/port_en.mdx";
import MDXPagePL from "@portfolios/port/port_pl.mdx";
import { automationDarkTheme, automationLightTheme } from "@themes/portfolio";

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}

const ThemedPage = () => {
  const { locale } = useRouter();
  const appContext = useContext(AppContext);

  return (
    <>
      <ThemeProvider
        theme={
          appContext.theme === ThemeMode.Light
            ? automationLightTheme
            : automationDarkTheme
        }
      >
        {locale === "pl" ? <MDXPagePL /> : <MDXPageEN />}
      </ThemeProvider>
    </>
  );
};

export default function Port() {
  return <ThemedPage />;
}
